import { ArrowLeftOutlined } from "@ant-design/icons";
import React, { Component } from "react";

class BackButtonLink extends Component {
  state = {};
  handleBackButton = () => {
    window.history.back();
  };

  render() {
    return (
      <div className="mt-1 mb-1">
        <p className="left-text-align">
          <button type="button" className="btn" onClick={this.handleBackButton}>
            <span className="login-form__bold-text_back">Back</span>
            <span className="back_arrow">
              <ArrowLeftOutlined />
            </span>
          </button>
        </p>
      </div>
    );
  }
}

export default BackButtonLink;
